import { defineMessages } from 'react-intl';

export const projectComposerLoadingFileCardMessages = defineMessages({
  unknownType: {
    defaultMessage: 'Unknown',
    id: '9B10cLwQ59',
    description: 'Fallback file type label while a composer attachment uploads',
  },
  deleteFile: {
    defaultMessage: 'Delete file',
    id: 'tB7xDYKWGx',
    description: 'Accessible label on remove for a loading composer attachment',
  },
});
